import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Paper from "@material-ui/core/Paper";
import Draggable from "react-draggable";
import { makeStyles } from "@material-ui/core/styles";
import EmailTemplateService from "../services/EmailTemplateService";
import notify from "../utils/notifier";
import IconButton from "@material-ui/core/IconButton";
import Util from "../utils/Util";
import { useTranslation } from "react-i18next";
import EmailRoundedIcon from '@material-ui/icons/EmailRounded';
import Tooltip from "@material-ui/core/Tooltip";
import InputLabel from "@material-ui/core/InputLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
import { Input, Typography, FormHelperText } from "@material-ui/core";
import TextField from '@material-ui/core/TextField';
import FormControl from "@material-ui/core/FormControl";

const useStyles = makeStyles(theme => ({
    button: {
        margin: theme.spacing(1)
    },
    metadata: {
        marginTop: 0,
        paddingBottom: 15
    },
    emailId: {
        marginBottom: 15,
    }
}));

function PaperComponent(props) {
    return (
        <Draggable cancel={'[class*="MuiDialogContent-root"]'}>
            <Paper {...props} />
        </Draggable>
    );
}

export default function SendEmailModal(props) {
    const [t] = useTranslation();
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);

    const [row, setRow] = React.useState('');
    const [rowId, setRowId] = React.useState('');
    const [outputType] = React.useState({ value: "html" });
    const [emailId, setEmailId] = React.useState('');
    const [values, setValues] = React.useState({
        disable: true,
        valid: true
    });

    const [metadata, setMetadata] = React.useState({
        value: ''
    });
    // Update row metadata on change
    React.useEffect(() => {
        setRow(props.row);
        setRowId(props.rowId)
        setMetadata({
            value: JSON.stringify(Util.toJSONObj(Util.toString(props.row["metadata"])), undefined, 4)
        });
    }, [props.row["metadata"]])

    const [validFrom, setValidFrom] = React.useState(true);

    const validateEmail = email => {
        return Util.validateEmail(email);
    };

    const handleMetadataChange = event => {
        let meta = Util.toJSONObj(event.target.value);
        let fromEmail = '';
        if (!(meta.from === undefined)) {
            fromEmail = meta.from;
        }
        let isValid = validateEmail(fromEmail);
        setValidFrom(isValid);
        setMetadata({
            value: event.target.value
        });
        setValues({ disable: !isValid });
    };

    const handleEmailChange = event => {
        setEmailId(event.target.value);
        handleValidationChange(event);
    };

    const handleValidationChange = event => {
        setValues({
            disable: !validateEmail(event.target.value),
            valid: !validateEmail(event.target.value)
        });
    };

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const generateSample = (templateName, row) => {
        let reqObj = {
            templateName: row["templateName"],
            metadata: metadata.value,
            organizationId: row["organizationId"],
            applicationId: row["applicationId"],
            recipientEmails: emailId,
            options: {
                type: outputType.value
            }
        };
        EmailTemplateService.sendEmail(reqObj).then(
            response => {
                notify({
                    type: "success",
                    message: "Email has been sent successfully"
                });
            },
            error => {
                notify({
                    type: "error",
                    message: "Error: " + error.response.data.errorCode
                });
            }
        );

        handleClose();
    };

    return (
        <div>
            <Tooltip title="Send Email" placement="top">
                <IconButton
                    aria-label="edit"
                    color="primary"
                    size="small"
                    onClick={handleClickOpen}
                >
                    <EmailRoundedIcon fontSize="inherit" />
                </IconButton>
            </Tooltip>
            <Dialog
                open={open}
                PaperComponent={PaperComponent}
                fullWidth={true}
                maxWidth="sm"
            >
                <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
                    <Typography component={'span'} variant='h6'>{t("Send a sample email " + row["templateName"])}</Typography>
                </DialogTitle>
                <DialogContent>
                    <div className={classes.emailId}>
                        <FormControl fullWidth>
                            <InputLabel >Email Id</InputLabel>
                            <Input
                                error={values.valid}
                                autoFocus={true}
                                name={'emailId'}
                                value={emailId}
                                type={'email'}
                                onChange={handleEmailChange}
                                startAdornment={<InputAdornment position="start">@:</InputAdornment>}
                            />
                            <FormHelperText style={{ color: '#f44336' }}>{values.valid ? 'Enter a valid email address' : ''}</FormHelperText>
                        </FormControl>
                    </div>
                    <div>
                        <InputLabel id="sample-metadata-label">{t("Metadata")}*</InputLabel>
                        <TextField
                            id="sample-metadata"
                            // labelId="sample-metadata-label"
                            error={!validFrom}
                            multiline
                            fullWidth
                            required
                            rows="4"
                            className={classes.metadata}
                            margin="normal"
                            value={metadata.value}
                            onChange={handleMetadataChange}
                            helperText={validFrom ? '' : 'Enter a proper from email address'}
                        />
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={handleClose} color="secondary">
                        {t("CANCEL")}
                    </Button>
                    <Button
                        disabled={values.disable}
                        onClick={() => {
                            generateSample(rowId, row);
                        }}
                        color="primary"
                    >
                        {t("SEND")}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}